import React, { useContext } from "react";
import {
  commitMutation,
  graphql,
  useLazyLoadQuery,
  usePreloadedQuery,
} from "react-relay";
import { GreenMachineContext } from "../../../GreenMachineContext";
import { GET_STACKS_FOR_SESSION } from "../../index";
import relayEnvironment from "../../../../../../../RelayEnvironment";
import { COMMIT_STACK_RULE_CHANGES } from "../mutations/CommitStackRuleChanges";
import { DELETE_STACK_RULE } from "./mutations/DeleteStackRule";

export default function StackList(props) {
  const { greenMachineSessionID } = useContext(GreenMachineContext);

  const stackData = usePreloadedQuery(
    GET_STACKS_FOR_SESSION,
    props.queryReference
  );

  function deleteStack(e, stackID) {
    e.preventDefault();

    commitMutation(relayEnvironment, {
      mutation: DELETE_STACK_RULE,
      variables: {
        input: {
          stackId: stackID,
        },
      },
      onCompleted: (content, errors) => {
        props.reloadStackList(
          {
            greenMachineSessionID: greenMachineSessionID,
          },
          { fetchPolicy: "network-only" }
        );
      },
      onError: (error) => {
        console.log(error);
      },
    });
  }

  return (
    <div className="stack-list-container">
      {stackData && stackData.stackRulesForGreenMachineSession ? (
        stackData.stackRulesForGreenMachineSession.map((rule) => {
          return (
            <div key={rule.id}>
              <p>
                <strong>
                  {rule.stackRule.displayName} {rule.stackValue}
                </strong>{" "}
                of:
              </p>
              <p>
                {rule.newPlayers.edges
                  .map((player) => {
                    const locked = player.node.greenmachinesessionstackruleplayerSet.edges.some(
                      (edge) => edge.node.locked
                    );

                    const playerNameSplit = player.node.slatePlayer.player.name.split(
                      / (.+)/
                    );

                    let playerName = playerNameSplit[1];

                    if (playerNameSplit.length === 1) {
                      playerName = playerNameSplit[0];
                    }

                    return playerName + (locked ? " (LOCK)" : "");
                  })
                  .join(", ")}
              </p>
              <p>
                in <strong>{rule.numLineups}</strong> lineups.
              </p>
              {rule.gcStaffStack ? (
                <p>
                  <strong>GC STAFF STACK</strong>
                </p>
              ) : null}
              <p>
                <button onClick={(e) => deleteStack(e, rule.id)}>
                  Delete Stack
                </button>
              </p>
              <hr />
            </div>
          );
        })
      ) : (
        <p>No stacks to display.</p>
      )}
    </div>
  );
}
